import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "./Weather.css";
import WeatherForecast from "./WeatherForecast";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
      date: new Date(response.data.dt * 1000),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "bc6d2694c7f4e9ac9094666861724dff";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="container">
        <div className="Weather">
          <div className="searchForm">
            <form onSubmit={handleSubmit}>
              <input
                className="formControl"
                type="search"
                placeholder="Search City.."
                onChange={updateCity}
              />
              <input
                className="searchButton"
                value="search"
                type="image"
                src="https://s3.amazonaws.com/shecodesio-production/uploads/files/000/056/836/original/icons8-search-100_%281%29.png"
                alt=""
              />
            </form>
          </div>
        </div>
        <h5 className="formattedDate">
          <FormattedDate date={weatherData.date}></FormattedDate>
        </h5>

        <div className="weatherInfo">
          <div className="row weather">
            <div className="row weatherDescription">
              <p className="text-capitalize">{weatherData.description}</p>
            </div>

            <div className="col mainWeather">
              <div className="weatherIcon">
                <WeatherIcon code={weatherData.icon} />
              </div>
              <div className="city">{weatherData.city}</div>
              <div className="temperature">
                <WeatherTemperature celsius={weatherData.temperature} />
              </div>
            </div>

            <div className="col otherInfo">
              <ul className="info">
                <li>
                  Humidity: <span>{weatherData.humidity} %</span>
                </li>
                <li>
                  Wind: <span>{weatherData.wind} km/h</span>
                </li>
              </ul>
            </div>

            <div className="weatherForecast">
              <WeatherForecast coordinates={weatherData.coordinates} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
